module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_resort@3x-bf20e28dee3c11399f2c41aa606e81d6.webp";